module.exports = __webpack_public_path__ + "img/mark-myfolder-copy.aa1ddc7.svg";